import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';

import { CDSMask } from '@app/utils/cds-mask';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-rel-financeiro-previsaomovimentacao',
  templateUrl: './previsao-movimentacao.component.html',
  styleUrls: ['./previsao-movimentacao.component.scss']
})
export class RelatorioPrevisaoMovimentacaoComponent implements OnInit {


  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService
  ) {
    this.filtros = {
      ContaId: null,
      DataInicial: UtilitarioService.retornaDataAtualMaisDias(0),
      DataFinal: UtilitarioService.retornaDataAtualMaisDias(30),
    };
  }

  rel: any;
  relResumo: any;
  cdsMask: CDSMask = new CDSMask();
  filtros: any;
  modalRef: BsModalRef;
  resumoDia: any;
  lstUnidades: IdDescricao[] = [];
  pesquisando: boolean;
  showTable = false;

  dataRelatorio: Date;

  @ViewChild('relatorio') relatorio: ElementRef;

  ngOnInit(): void {
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
  }

  pesquisar() {
    this.dataRelatorio = new Date();
    this.rel = null;
    this.pesquisando = true;
    this.relatorioService.previsaoMovimentacao(this.filtros).toPromise()
      .then((data) => {
        this.rel = data;
        this.pesquisando = false;

        if (this.rel === null) {
          this.showTable = false;
          this.toastr.info('Busca não encontrou resultados');
        } else {
          this.showTable = true;
        }
      }, erro => {
        this.pesquisando = false;
        this.toastr.warning('Realize a pesquisa novamente.');
      });
  }
  public imprimir() {
    let conteudo = document.getElementById("relatorioPrevisao").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, 'Relatório previsão de movimentações', this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    
    parseDateAdicionaMap('Data Inicial', this.filtros.DataInicial);
    parseDateAdicionaMap('Data Final', this.filtros.DataFinal);
    
    obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.filtros.UnidadeId);

    

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

}

